import Button from "components/Button/Button";
import { BUTTON_COLOR } from "components/Button/Button.type";
import Checkbox from "components/CheckBox/CheckBox";
import Header from "components/Header/Header";
import Input from "components/Input/Input";
import { ICON } from "constants/icons";
// import { WEB_STORAGE_KEYS } from "constants/localStorageKey";
import { WEB_STORAGE_KEYS } from "constants/webStorageKey";
import { useAuth } from "hooks/feature/login/useAuth";
import { ChangeEvent, useEffect, useMemo, useState } from "react";
import { authStore } from "stores/auth-stores";
import { commonStore } from "stores/common-stores";
import { LoginParams } from "types/feature/login/login";
import { getSessionStorage, removeLocalStorage, setSessionStorage } from "utils/webStorage-utils";
import styles from "./Login.module.scss";

export default function Login() {
  const { setIsLoading } = commonStore();
  const { setLoginStatus } = authStore();
  const [formData, setFormData] = useState<LoginParams>({
    username: "",
    password: "",
  });

  const [isRemember, setIsRemeber] = useState(false);

  const [isError, setIsError] = useState(false);

  const { postLogin, getDownloadApkUrl } = useAuth();

  const [donwloadLink, setDownloadLink] = useState("https://editor-cell-ripeness-app.s3.ap-northeast-2.amazonaws.com/upload/apk/dabeeo_palm_ripeness.v.1.0.0.apk");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    handleGetUrl();
    if (getSessionStorage(WEB_STORAGE_KEYS.EE_LOGIN_USER_NAME)) {
      setFormData({
        username: getSessionStorage(WEB_STORAGE_KEYS.EE_LOGIN_USER_NAME),
        password: "",
      });
      setIsRemeber(true);
    }

    if (getSessionStorage(WEB_STORAGE_KEYS.LOGIN_STATUS) === "true") {
      setLoginStatus(true);
    }
  }, []);

  const handleGetUrl = async () => {
    const apkInfo = await getDownloadApkUrl();

    if (apkInfo) {
      setDownloadLink(apkInfo.url.replace(/^http:\/\//i, "https://"));
      setFileName(apkInfo.fileName);
    }
  };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.username.length === 0 || formData.password.length === 0) {
      setIsError(true);
      return;
    }

    const loginData: LoginParams = {
      ...formData,
      // password: window.btoa(formData.password), // password base64로 인코딩
    };

    setIsLoading(true);
    const response = await postLogin(loginData);
    if (response?.status === 200) {
      isRemember ? setSessionStorage(WEB_STORAGE_KEYS.EE_LOGIN_USER_NAME, formData.username) : removeLocalStorage(WEB_STORAGE_KEYS.EE_LOGIN_USER_NAME);
      setSessionStorage(WEB_STORAGE_KEYS.LOGIN_STATUS, "true");
      setSessionStorage(WEB_STORAGE_KEYS.USER_ID, String(response.data.id));
      setLoginStatus(true);
    } else {
      setIsError(true);
      setLoginStatus(false);
    }
    setIsLoading(false);
  };

  const handleChangeLoginForm = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  return (
    <div className={styles["login__container"]}>
      <Header menusVisible={false} downloadLink={donwloadLink} fileName={fileName}></Header>
      <div className={styles["login__body"]}>
        <form className={styles["login__wrap"]} onSubmit={handleLogin}>
          <img src={ICON.LOGO_DABEEO} style={{ width: 197, height: 68 }} alt="" />
          <div className={styles["input__area"]}>
            <Input width={360} colorMode="dark" placeholder="Please enter your ID" onChange={handleChangeLoginForm} id="username" showWarning={isError} defaultValue={formData.username || ""}></Input>
            <Input width={360} colorMode="dark" placeholder="Please enter your password" type="password" onChange={handleChangeLoginForm} id="password" showWarning={isError} defaultValue={formData.password || ""}></Input>
          </div>
          <div className={styles["check__area"]}>
            <Checkbox label="Remember ID" colorMode="dark" id="rememberID" checked={isRemember || false} onChange={() => setIsRemeber(!isRemember)}></Checkbox>
          </div>
          {isError && <div className={styles["warning__area"]}>Please check your ID or password.</div>}
          <Button color={BUTTON_COLOR.blue} width={360} text="LOG IN" type="submit"></Button>
        </form>
        <div className={styles["bottom__wrap"]}>
          <div className={styles["text-gray1"]}>Please contact dabeeo if you can't log in</div>
          <div className={styles["text-gray2"]}>cs.eartheye@dabeeo.com</div>
          <img className={styles["bottom-logo"]} src={ICON.LOGO_DABEEO} style={{ width: 80, height: 17.4 }} alt="" />
        </div>
      </div>
    </div>
  );
}
